module.exports = __webpack_public_path__ + "img/qr_admin.2a14acab.svg";